import { FileList } from "newui/components/FileUpload";
import { convertFileAbleFileToUploadedFile } from "newui/components/FileUpload/utils";
import { useMemo } from "react";

export const ViewSupplierResponse = ({ clarification }) => {

	const mappedInitialFiles = useMemo(
		() =>
			(clarification?.files ?? []).map((file) => convertFileAbleFileToUploadedFile(file)),
		[clarification?.files]
	);

	return (<><div className="rounded-lg bg-blue-50 p-4">
		<label className="mb-1 block text-sm font-medium text-gray-700">
			Supplier Response
		</label>
		<p className="text-sm text-gray-900 whitespace-pre-wrap">
			{clarification.final_response}
		</p>
	</div>
		<FileList isPreview files={mappedInitialFiles} />
	</>);
}